import { render, staticRenderFns } from "./catalogue-item.vue?vue&type=template&id=3c971b0d&scoped=true&"
import script from "./catalogue-item.vue?vue&type=script&lang=ts&"
export * from "./catalogue-item.vue?vue&type=script&lang=ts&"
import style0 from "./catalogue-item.vue?vue&type=style&index=0&id=3c971b0d&prod&lang=less&scoped=true&"
import style1 from "./catalogue-item.vue?vue&type=style&index=1&id=3c971b0d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c971b0d",
  null
  
)

export default component.exports